<template>
  <div class="edit-info">
    <div class="card">
      <div class="card-header">
        <span class="card-title">{{ pageTitle }}</span>
        <div class="card-actions">
          <el-button size="mini" type="warning" @click="submitForm">提交修改</el-button>
        </div>
      </div>
      <div class="card-body">
        <div v-if="loading" class="loading">
          <el-skeleton :rows="10" animated />
        </div>
        <div v-else>
          <PersonalInfoForm v-if="userType === 'H5_largescreen_personal'" ref="personalForm" v-model="personalFormData" :upload-url="uploadUrl" :mode="editMode" />
          <EnterpriseInfoForm v-else-if="userType === 'H5_largescreen_company'" ref="enterpriseForm" v-model="enterpriseFormData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import PersonalInfoForm from '../components/PersonalInfoForm.vue'
import EnterpriseInfoForm from '../components/EnterpriseInfoForm.vue'
import {getInfo} from '@/api/api';
export default {
  name: 'UserInfo',
  components: {
    PersonalInfoForm,
    EnterpriseInfoForm
  },
  data() {
    return {
      loading: true,
      userType: 'personal',
      userInfo: null,
      uploadUrl: '',
      editMode: 'info',
      personalFormData: {
        nickName: '',
        email: '',
        phonenumber:'',
        registerInfo:{
          personalPhoto: '',
          idType: '',
          idNumber: '',
          ethnicity: '',
          nativePlace: '',
          politicalStatus: '',
          gender: '',
          birthDate: '',
          maritalStatus: '',
          projectName: '',
          region: '',
          graduationDate: '',
          major: '',
          almaMater: '',
          highestEducation: '',
          highestEducationCertificate: '',
          unitNature: '',
          unitName: '',
          unitCategory: '',
          professionalTitle: '',
          position: '',
          supervisionType: '',
          workField: '',
          isCurrentlySocialWorker: '',
          socialWorkYears: '',
          socialWorkerCertificateLevel: '',
          certificateUpload: '',
          contactAddress: '',
          mobile: '',
          postalCode: '',
          socialWorkSpecialty: [],
          filingType: '',
          supportingDocuments: '',
          workExperiences: [
            {
              companyName: '',
              position: '',
              socialWorkType: '',
              startDate: '',
              endDate: '',
              description: ''
            }
          ],
          submitInstructions: ''
        }
      },
      enterpriseFormData: {
        organizationName: '',
        organizationCode: '',
        registrationType: '',
        establishmentDate: '',
        registrationAddress: '',
        organizationWebsite: '',
        businessScope: '',
        organizationEmail: '',
        postalCode: '',
        officePhone: '',
        fax: '',
        legalRepresentativeName: '',
        legalRepresentativeOfficePhone: '',
        phonenumber: '',
        legalRepresentativeOfficeEmail: '',
        legalRepresentativeIntro: '',
        contactName: '',
        contactDepartment: '',
        contactPosition: '',
        contactOfficePhone: '',
        contactMobile: '',
        contactEmail: '',
        contactQQ: '',
        contactMailingAddress: ''
      }
    }
  },
  computed: {
    pageTitle() {
      return this.editMode === 'employer' ? '修改工作单位' : '修改用户信息'
    }
  },
  watch:{
    '$route.query.mode':function(data){
      this.resetForm()
      this.editMode = data||'info'
    }
  },
  created() {
    this.loadUserInfo()
    this.editMode = this.$route.query.mode||'info'
  },
  methods: {
    loadUserInfo() {
      getInfo().then(userRes => {
        if (userRes.data.code === 200) {
          this.userType = userRes.data.data.roles[0] || 'H5_largescreen_personal'
          if (this.userType === 'H5_largescreen_personal') {
            this.personalFormData = userRes.data.data.user
          } else {
            this.enterpriseFormData = userRes.data.data.user
          }
          localStorage.setItem('userInfo', JSON.stringify(userRes.data.data))
        }
        this.loading = false
      })
      // this.userInfo = getUserInfo()
      // if (this.userInfo) {
      //   this.userType = this.userInfo.roles[0] || 'H5_largescreen_personal'
      //   if (this.userType === 'H5_largescreen_personal') {
      //     this.personalFormData = this.userInfo.user
      //   } else {
      //     this.enterpriseFormData = this.userInfo.user
      //   }
      // }
      
    },
    submitForm() {
      if (this.userType === 'H5_largescreen_personal') {
        this.$refs.personalForm.submitForm()
      } else if (this.userType === 'H5_largescreen_company') {
        this.$refs.enterpriseForm.submitForm()
      }
    },
    resetForm() {
      if (this.userType === 'H5_largescreen_personal') {
        this.$refs.personalForm.resetForm()
      } else if (this.userType === 'H5_largescreen_company') {
        this.$refs.enterpriseForm.resetForm()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.edit-info {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;
    overflow-y: auto;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }

      .card-actions {
        display: flex;
        gap: 10px;
      }
    }

    .loading {
      padding: 20px;
    }
  }
}
</style>
